<template>
  <div class="website-page">
    <!-- Header导航栏 -->
    <header class="website-header" :class="{ 'scrolled': isScrolled }">
      <div class="header-container">
        <div class="logo-section" @click="goToHomepage" style="cursor: pointer;">
          <img src="@/assets/logo/logo.png" alt="小虫单" class="logo-img" />
          <span class="logo-text">小虫单</span>
        </div>
        
        <nav class="nav-menu">
          <a href="#home" class="nav-link" @click.prevent="scrollTo('home')">首页</a>
          <a href="#product-functions" class="nav-link" @click.prevent="scrollTo('product-functions')">产品功能</a>
          <a href="#pricing" class="nav-link" @click.prevent="scrollTo('pricing')">版本价格</a>
          <a href="#about" class="nav-link" @click.prevent="scrollTo('about')">关于我们</a>
        </nav>
        
        <div class="header-actions">
<!--          <span class="contact-info">-->
<!--            <svg class="phone-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--              <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" fill="currentColor"/>-->
<!--            </svg>-->
<!--            15081250919-->
<!--          </span>-->
          <el-button type="text" class="action-btn" @click="handleLogin">登录/注册</el-button>
          <el-button type="text" class="download-header-btn" @click="handleDownload">下载小虫单</el-button>
          <el-button type="warning" class="contact-header-btn" @click="handleContact">联系销售</el-button>
        </div>
      </div>
      
      <!-- Header横幅 -->
      <div class="header-banner">
        <div class="banner-content">
          <div class="banner-text-wrapper">
            <span class="banner-text banner-text-white">小虫单，真简单</span>
            <span class="banner-divider">|</span>
            <span class="banner-text banner-text-yellow">为中小型消杀企业量身打造的移动工单！</span>
            <el-button type="warning" class="banner-trial-btn" @click="handleTrial">免费试用 ></el-button>
          </div>

        </div>
      </div>
    </header>

    <!-- Hero区域 -->
    <section id="home" class="hero-section">
      <div class="hero-image-wrapper">
        <!-- 第一张图片作为占位，确定容器高度 -->
        <div class="hero-image-item hero-image-placeholder">
          <img 
            :src="heroImages[0].src" 
            :alt="heroImages[0].alt" 
            class="hero-main-image"
            @error="handleImageError($event)"
          />
        </div>
        <!-- 轮播图片 -->
        <div 
          v-for="(image, index) in heroImages" 
          :key="'carousel-' + index"
          class="hero-image-item hero-image-carousel"
          :class="{ 'active': currentHeroIndex === index }"
        >
          <img 
            :src="image.src" 
            :alt="image.alt" 
            class="hero-main-image"
            @error="handleImageError($event)"
          />
        </div>
        <!-- Hero内容区域（包含文字和Logo，使用flex布局避免重合） -->
        <div class="hero-content-wrapper">
          <!-- 左侧文字和按钮（第一张图片） -->
          <div 
            v-if="currentHeroIndex === 0"
            class="hero-content"
          >
            <h1 class="hero-title">移动办公</h1>
            <ul class="hero-features">
              <li>人人会用,手机就是工单中心。</li>
              <li>工单管理与填报,一部手机全部搞定;</li>
              <li>直观易用,无需专门培训。</li>
            </ul>
          </div>
          <!-- 左侧文字和按钮（第二张图片） -->
          <div 
            v-if="currentHeroIndex === 1"
            class="hero-content"
          >
            <h1 class="hero-title hero-title-white">优质订单</h1>
            <ul class="hero-features hero-features-white">
              <li>标准化、全流程工单系统与个性化AI服务
                <br>报告携手巩固客户信任,获取转化优质订单</li>
            </ul>
          </div>
          <!-- 左侧文字和按钮（第三张图片） -->
          <div 
            v-if="currentHeroIndex === 2"
            class="hero-content"
          >
            <h1 class="hero-title">降本增效</h1>
            <ul class="hero-features">
              <li>高效一月,仅需一餐。</li>
              <li>仅投入一顿快餐的钱,就可提升一整月的工作效率。</li>
            </ul>
          </div>
          <!-- Logo（第一张图片显示headLogo.png，第二张图片显示headLogo2.png） -->
          <div 
            v-if="currentHeroIndex === 0"
            class="hero-logo"
          >
            <img 
              src="@/assets/imgsNew/headLogo.png" 
              alt="小虫单Logo" 
              class="hero-logo-img"
              @error="handleImageError($event)"
            />
          </div>
          <div 
            v-if="currentHeroIndex === 1"
            class="hero-logo hero-logo-second"
          >
            <img 
              src="@/assets/imgsNew/headLogo2.png" 
              alt="小虫单Logo" 
              class="hero-logo-img"
              @error="handleImageError($event)"
            />
          </div>
          <div 
            v-if="currentHeroIndex === 2"
            class="hero-logo hero-logo-third"
          >
            <img 
              src="@/assets/imgsNew/headLogo3.png" 
              alt="小虫单Logo" 
              class="hero-logo-img"
              @error="handleImageError($event)"
            />
          </div>
        </div>
        <!-- 轮播指示器 -->
        <div class="hero-indicators">
          <span
            v-for="(image, index) in heroImages"
            :key="'indicator-' + index"
            class="hero-indicator"
            :class="{ 'active': currentHeroIndex === index }"
            @click="switchHeroImage(index)"
          ></span>
        </div>
      </div>
    </section>

    <!-- 能力亮点卡片区域 -->
    <section class="feature-highlight-section">
      <div class="feature-container">
        <div class="feature-cards-container">
          <div
            v-for="(feature, index) in featureSections"
            :key="feature.title"
            class="feature-card"
            :style="{ animationDelay: `${index * 0.1}s` }"
          >
            <!-- 图片区域 -->
            <div class="feature-image-wrapper">
              <div class="feature-image-container">
                <img 
                  :src="feature.imagePlaceholder" 
                  :alt="feature.title"
                  class="feature-image"
                  @error="handleImageError($event)"
                />
              </div>
            </div>
            
            <!-- 文案区域 -->
            <div class="feature-text">
              <h3 class="feature-title">{{ feature.title }}</h3>
              <p class="feature-desc">{{ feature.desc }}</p>
              <el-link
                type="primary"
                class="feature-link"
                @click.prevent="scrollTo('product-functions')"
              >
                {{ feature.linkText }}
              </el-link>
            </div>
          </div>
        </div>
      </div>
    </section>



    <!-- 产品功能 -->
    <section id="product-functions" class="product-functions-section">
      <div class="product-functions-container">
        <h2 class="product-functions-title">产品功能</h2>
        
        <div class="function-systems-grid">
          <div
            v-for="system in safeProductSystems"
            :key="system.key"
            class="function-system-card"
          >
            <!-- 标题 -->
            <h3 class="function-system-title">{{ system.name }}</h3>
            
            <!-- 功能项网格 -->
            <div 
              class="function-items-container"
              :class="'layout-' + system.layout"
            >
              <div
                v-for="(item, itemIndex) in system.items"
                :key="itemIndex"
                class="function-item"
              >
                <div class="function-item-icon-wrapper">
                  <img :src="item.icon" :alt="item.name" class="function-item-icon" />
                </div>
                <span class="function-item-text">{{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 版本价格 -->
    <section id="pricing" class="pricing-section">
      <div class="pricing-container">
        <h2 class="section-title">为您的企业选择最佳方案套餐</h2>
        <p class="section-subtitle">智能化的虫控管理平台,让纸质化成为过去!</p>

        <div class="pricing-cards">
          <div
            v-for="(plan, index) in pricingPlans"
            :key="index"
            class="pricing-card"
          >
            <h3 class="plan-title">{{ plan.title }}</h3>
            <p class="plan-description">{{ plan.description }}</p>
            
            <!-- 价格信息 -->
            <div class="plan-pricing">
              <div class="pricing-item pricing-item-monthly">
                <span class="pricing-value">
                  {{ plan.monthlyPrice.replace('/月', '') }}<span class="pricing-month">/月</span>
                </span>
                <span class="pricing-note-inline">(年付折合 / 每账号)</span>
              </div>
              <div class="pricing-item pricing-item-period">
                <span class="pricing-period-text">年付 {{ plan.annualPrice.replace('/年', '') }} | 季度 {{ plan.quarterlyTotal.replace('/季度', '') }}</span>
              </div>
              <div class="pricing-note pricing-note-inside">
                <span class="pricing-note-text">每个登录账号单独计费</span>
              </div>
            </div>
            
            <!-- 存储空间 -->
            <div class="plan-specs">
              <div class="spec-item">
                <span class="spec-label">存储空间:</span>
                <span class="spec-value">{{ plan.storage }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 功能对比配置（上方为入口配置对比，下方为功能对比） -->
    <section class="feature-comparison-section">
      <div class="feature-comparison-container">
        <h2 class="feature-comparison-title">核心功能对比</h2>
        <p class="feature-comparison-subtitle">不同版本覆盖的核心能力一目了然,方便您按需选择</p>

        <!-- 使用入口对比表 -->
        <div class="usage-comparison-table">
          <div class="usage-comparison-header">
            <div class="usage-col usage-col-name">使用入口</div>
            <div
              v-for="plan in pricingPlans"
              :key="plan.title + '-usage-header'"
              class="usage-col usage-col-plan"
            >
              {{ plan.title }}
            </div>
          </div>

          <div
            v-for="entry in usageEntries"
            :key="entry.key"
            class="usage-row"
          >
            <div class="usage-col usage-col-name">
              <div class="usage-info">
                <div class="usage-name">{{ entry.name }}</div>
                <div class="usage-desc">{{ entry.desc }}</div>
              </div>
            </div>
            <div
              v-for="plan in pricingPlans"
              :key="plan.title + '-' + entry.key"
              class="usage-col usage-col-plan"
            >
              <span
                v-if="isUsageEnabled(entry.key, plan.title)"
                class="feature-dot feature-dot-yes"
              >
                ✓
              </span>
              <span
                v-else
                class="feature-dot feature-dot-na"
              ></span>
            </div>
          </div>
        </div>

        <div class="feature-comparison-table">
          <div class="feature-comparison-header">
            <div class="feature-col feature-col-name">功能模块</div>
            <div
              v-for="plan in pricingPlans"
              :key="plan.title"
              class="feature-col feature-col-plan"
            >
              {{ plan.title }}
            </div>
          </div>

          <div
            v-for="feature in featureComparison"
            :key="feature.key"
            class="feature-row"
          >
            <div class="feature-col feature-col-name">
              <div class="feature-info">
                <div class="feature-name">{{ feature.name }}</div>
                <div class="feature-desc">{{ feature.desc }}</div>
              </div>
            </div>
            <div
              v-for="plan in pricingPlans"
              :key="plan.title + '-' + feature.key"
              class="feature-col feature-col-plan"
            >
              <span
                v-if="isFeatureEnabled(feature.key, plan.title)"
                class="feature-dot feature-dot-yes"
              >
                ✓
              </span>
              <span
                v-else
                class="feature-dot feature-dot-na"
              ></span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 关于我们 -->
    <section id="about" class="about-section">
      <div class="about-background">
        <img 
          src="@/assets/imgsNew/about.png"
          alt="关于我们背景" 
          class="about-bg-image"
          @error="handleImageError($event)"
        />
        <div class="about-bg-overlay"></div>
      </div>
      <div class="about-container">
        <h2 class="section-title">关于我们</h2>
        <div class="about-cards">
          <div
            v-for="(item, index) in aboutItems"
            :key="index"
            class="about-card"
          >
            <div class="about-card-image-wrapper">
              <img 
                :src="item.image || 'https://via.placeholder.com/120x120?text=占位符'" 
                :alt="item.title"
                class="about-card-image"
                @error="handleImageError($event)"
              />
            </div>
            <h3 class="about-card-title">{{ item.title }}</h3>
            <p class="about-card-content">{{ item.content }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 下载二维码弹窗 -->
    <el-dialog
      :model-value="downloadDialogVisible"
      @update:model-value="handleDialogClose"
      title=""
      width="720px"
      :show-close="true"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      class="download-dialog"
      center
    >
      <div class="download-content">
        <h2 class="download-title">
          <span class="title-text-black">下载</span>
          <span class="title-text-blue">小虫单APP</span>
        </h2>
        <p class="download-desc">让智能管理赋能虫害防制,让企业更高效、更具竞争力!</p>
        <div class="qr-codes-row">
          <div 
            class="qr-card qr-card-android" 
            :class="{ 'is-revealed-tap': qrRevealedPlatform === 'android' }"
          >
            <div class="qr-card-reveal">
              <div class="qr-code-layer">
                <img 
                  src="@/assets/app.png" 
                  alt="安卓下载二维码" 
                  class="qr-code-image"
                  @error="handleQrCodeError"
                />
              </div>
              <div class="qr-mask-layer" @click="qrRevealedPlatform = 'android'">
                <img src="@/assets/Android.png" alt="安卓" class="qr-mask-icon" />
                <span class="qr-mask-label">Android 客户端</span>
              </div>
            </div>
            <p class="qr-card-hint">扫码下载安卓版</p>
          </div>
          <div 
            class="qr-card qr-card-ios" 
            :class="{ 'is-revealed-tap': qrRevealedPlatform === 'ios' }"
          >
            <div class="qr-card-reveal">
              <div class="qr-code-layer">
                <img 
                  :src="iosQrSrc" 
                  alt="iOS下载二维码" 
                  class="qr-code-image"
                  @error="handleQrCodeError"
                />
              </div>
              <div class="qr-mask-layer" @click="qrRevealedPlatform = 'ios'">
                <img src="@/assets/Apple.png" alt="苹果" class="qr-mask-icon" />
                <span class="qr-mask-label">iOS & iPadOS 客户端</span>
              </div>
            </div>
            <p class="qr-card-hint">扫码跳转 App Store</p>
          </div>
        </div>
        <p class="download-hint">悬停或点击卡片显示二维码; 使用手机浏览器扫一扫下载APP</p>
      </div>
    </el-dialog>

    <!-- Footer -->
    <footer class="website-footer">
      <div class="footer-container">
        <h2 class="footer-title">小虫单,真简单</h2>
        <p class="footer-subtitle">欢迎联系我们,小虫单顾问将为您提供全力支持</p>
        <div class="footer-logo">
          <img src="@/assets/imgsNew/bottomlogo.png" alt="小虫单" class="footer-logo-img" />
        </div>
        <div class="footer-actions">
          <el-button type="primary" class="footer-btn download-btn" @click="handleDownload">立即下载</el-button>
          <el-button type="warning" class="footer-btn contact-btn" @click="handleContact">联系我们</el-button>
        </div>
        <div class="footer-copyright">
          <p>Copyright © 2026 河北雄安思知科技有限公司  <a href="https://beian.miit.gov.cn/" target="_blank" style="margin-right: 10px;">冀ICP备2025136342号-1</a> <img src="@/assets/imgs/beian.png" alt="冀公网安备13310102000210号" style="width: 16px; height: 16px;margin-left: 10px;"> <a href="https://beian.mps.gov.cn/#/query/webSearch?code=13310102000210" rel="noreferrer" target="_blank" >冀公网安备13310102000210号</a></p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'WebsiteHomepage',
  data() {
    return {
      isScrolled: false,
      downloadDialogVisible: false,
      qrRevealedPlatform: null,
      // Hero轮播图片
      heroImages: [
        {
          src: require('@/assets/imgsNew/headNew.png'),
          alt: '小虫单移动工单系统 - 降本增效'
        },
        {
          src: require('@/assets/imgsNew/headNew2.png'),
          alt: '小虫单移动工单系统 - 接单易用'
        },
        {
          src: require('@/assets/imgsNew/headNew3.png'),
          alt: '小虫单移动工单系统 - 优质订单'
        }
      ],
      currentHeroIndex: 0,
      heroCarouselTimer: null,
      // 首页能力亮点卡片（4个卡片）
      featureSections: [
        {
          title: '智能定位监管,让外勤管理透明高效',
          desc: '智能定位,轨迹实时可见;店铺打卡,动态自动核验。杜绝谎报,让外勤管理透明高效。',
          linkText: '更多功能 >',
          imagePlaceholder: require('@/assets/imgsNew/function1.png')
        },
        {
          title: '全流程移动化办公',
          desc: '填单、派单、转单、查询,一部手机,搞定工单全流程。',
          linkText: '更多功能 >',
          imagePlaceholder: require('@/assets/imgsNew/function2.png')
        },
        {
          title: 'AI 排班,解锁高效人力调度',
          desc: '导入任务数据,AI赋能调度,规划最优路线,生成高效排班,让有限人力,成就事半功倍。',
          linkText: '更多功能 >',
          imagePlaceholder: require('@/assets/imgsNew/function3.png')
        },
        {
          title: 'AI生成专业报告,服务价值数字化',
          desc: 'AI 智能生成专业服务报告,工单完成实时发送。将每次服务转化为可信赖的数字凭证,提升客户的信任与满意度。',
          linkText: '更多功能 >',
          imagePlaceholder: require('@/assets/imgsNew/function4.png')
        },
        {
          title: '无界协同,让客户、团队与数据智慧流动的管理系统',
          desc: '打破信息壁垒,实现客户、团队、数据的无缝协同,让高效管理成为常态。',
          linkText: '更多功能 >',
          imagePlaceholder: require('@/assets/imgsNew/function5.png')
        },
      ],
      // 产品功能配置（4个系统）
      productSystems: [
        {
          key: 'order',
          name: '工单管理',
          anchorId: 'section-order-system',
          layout: 'grid-2x2', // 2x2网格布局
          items: [
            { name: '工单填写', icon: require('@/assets/imgsNew/config1.png') },
            { name: '秒派单', icon: require('@/assets/imgsNew/config2.png') },
            { name: '转单审批', icon: require('@/assets/imgsNew/config3.png') },
            { name: '工单查询', icon: require('@/assets/imgsNew/config4.png') }
          ]
        },
        {
          key: 'management',
          name: '管理系统',
          anchorId: 'section-management-system',
          layout: 'vertical-2', // 2列垂直布局
          items: [
            { name: '客户管理', icon: require('@/assets/imgsNew/config5.png') },
            { name: '员工管理', icon: require('@/assets/imgsNew/config6.png') }
          ]
        },
        {
          key: 'scheduling',
          name: '排班系统',
          anchorId: 'section-scheduling-system',
          layout: 'vertical-2', // 2列垂直布局
          items: [
            { name: '人工排班', icon: require('@/assets/imgsNew/config7.png') },
            { name: 'AI排班', icon: require('@/assets/imgsNew/config8.png') }
          ]
        },
        {
          key: 'report',
          name: '报表系统',
          anchorId: 'section-report-system',
          layout: 'vertical-3', // 3列垂直布局
          items: [
            { name: '服务报告', icon: require('@/assets/imgsNew/config9.png') },
            { name: '数据分析', icon: require('@/assets/imgsNew/config10.png') }
          ]
        }
      ],
      // 版本价格配置（3个套餐）
      pricingPlans: [
        {
          title: '标准版',
          icon: require('@/assets/imgsNew/yesIcon.png'),
          description: '初创企业:无需复杂系统,一部手机就能完成管理和工单操作。',
          monthlyPrice: '¥9.9/月',
          annualPrice: '¥118.8/年',
          quarterlyPrice: '¥44.7/季度',
          quarterlyTotal: '¥44.7/季度',
          storage: '50M',
          minAccounts: 3,
          features: ['电子工单', '管理后台', '人工排班'],
          linkText: '更多功能 >'
        },
        {
          title: '专业版',
          icon: require('@/assets/imgsNew/yesIcon.png'),
          description: '中小型企业:管理工人、客户和工单更轻松,不用额外培训。',
          monthlyPrice: '¥19.9/月',
          annualPrice: '¥238.8/年',
          quarterlyPrice: '¥74.7/季度',
          quarterlyTotal: '¥74.7/季度',
          storage: '500M',
          minAccounts: 3,
          features: ['电子工单', '人工排班', '智能报告 50次/月', '智能排班 10次/月', '管理后台'],
          linkText: '更多功能 >'
        },
        {
          title: '旗舰版',
          icon: require('@/assets/imgsNew/yesIcon.png'),
          description: '大型企业:工单系统+AI排班,让少量员工完成更多服务,提高专业度。',
          monthlyPrice: '¥49.9/月',
          annualPrice: '¥598.8/年',
          quarterlyPrice: '¥179.7/季度',
          quarterlyTotal: '¥179.7/季度',
          storage: '5G',
          minAccounts: 5,
          features: ['电子工单', '人工排班', '个性化报告 100页/年', '智能排班不限次数', '功能拓展'],
          linkText: '更多功能 >'
        }
      ],
      // 使用入口配置
      usageEntries: [
        {
          key: 'managerPC',
          name: '主管工作台 - 电脑端',
          desc: '主管在电脑上做排班、管理、审核'
        },
        {
          key: 'managerMobile',
          name: '主管工作台 - 手机端',
          desc: '外出也能管业务、派单、看进度'
        },
        {
          key: 'technicianMobile',
          name: '技术员外勤 - 手机端',
          desc: '签到、拍照、填工单、做报告'
        }
      ],
      // 功能对比配置
      featureComparison: [
        {
          key: 'electronicWorkOrder',
          name: '工单管理 - 电子工单',
          desc: '手机填写工单,现场拍照签字'
        },
        {
          key: 'personalizedWorkOrder',
          name: '工单管理 - 个性化工单',
          desc: '专属工单流程'
        },
        {
          key: 'serviceReport',
          name: '工单管理 - 服务报告',
          desc: '工单完成自动生成报告，标准版带水印'
        },
        {
          key: 'dispatchTransfer',
          name: '工单管理 - 派单转单',
          desc: '新增工单，修改工单，转单审核'
        },
        {
          key: 'customerData',
          name: '客户管理 - 客户资料',
          desc: '记录客户信息、历史服务记录'
        },
        {
          key: 'contractManagement',
          name: '客户管理 - 合同管理',
          desc: '合同到期提醒'
        },
        {
          key: 'workerFiles',
          name: '员工管理 - 工人档案',
          desc: '管理工人信息和工作记录'
        },
        {
          key: 'employeeCheckin',
          name: '员工管理 - 员工签到',
          desc: '到场/离场定位，防止漏单或假单'
        },
        {
          key: 'employeeLocation',
          name: '员工管理 - 员工分布',
          desc: '实时监测员工位置'
        },
        {
          key: 'batchScheduling',
          name: '员工管理 - 批量排班',
          desc: '主管随时安排人员、调整时间'
        },
        {
          key: 'aiScheduling',
          name: '员工管理 - AI排班',
          desc: 'AI系统自动推荐排班方案'
        },
        {
          key: 'dataStatistics',
          name: '数据统计',
          desc: '统计工人任务、工时、物料使用等情况'
        },
        {
          key: 'brandCustomization',
          name: '品牌定制',
          desc: '服务报告专属企业Logo和印章，报告去水印等'
        },
        {
          key: 'featureExpansion',
          name: '功能拓展',
          desc: '根据需要增加功能(视复杂程度收取一次性开发费用）'
        }
      ],
      // 功能-版本映射（按 标准版 / 专业版 / 旗舰版 区分）
      featureMatrix: {
        electronicWorkOrder: {
          '标准版': true,
          '专业版': true,
          '旗舰版': true
        },
        personalizedWorkOrder: {
          '标准版': false,
          '专业版': true,
          '旗舰版': true
        },
        serviceReport: {
          '标准版': true,
          '专业版': true,
          '旗舰版': true
        },
        dispatchTransfer: {
          '标准版': true,
          '专业版': true,
          '旗舰版': true
        },
        customerData: {
          '标准版': true,
          '专业版': true,
          '旗舰版': true
        },
        contractManagement: {
          '标准版': false,
          '专业版': true,
          '旗舰版': true
        },
        workerFiles: {
          '标准版': true,
          '专业版': true,
          '旗舰版': true
        },
        employeeCheckin: {
          '标准版': false,
          '专业版': true,
          '旗舰版': true
        },
        employeeLocation: {
          '标准版': false,
          '专业版': true,
          '旗舰版': true
        },
        batchScheduling: {
          '标准版': false,
          '专业版': true,
          '旗舰版': true
        },
        aiScheduling: {
          '标准版': false,
          '专业版': false,
          '旗舰版': true
        },
        dataStatistics: {
          '标准版': false,
          '专业版': true,
          '旗舰版': true
        },
        brandCustomization: {
          '标准版': false,
          '专业版': true,
          '旗舰版': true
        },
        featureExpansion: {
          '标准版': false,
          '专业版': false,
          '旗舰版': true
        }
      },
      // 使用入口-版本映射（按 标准版 / 专业版 / 旗舰版 区分）
      usageMatrix: {
        managerPC: {
          '标准版': false,
          '专业版': true,
          '旗舰版': true
        },
        managerMobile: {
          '标准版': true,
          '专业版': true,
          '旗舰版': true
        },
        technicianMobile: {
          '标准版': true,
          '专业版': true,
          '旗舰版': true
        }
      },
      // 关于我们配置
      aboutItems: [
        {
          title: '行业痛点',
          icon: 'el-icon-aim',
          content: '您的PCO公司是否也面临这些困境呢?繁瑞的工单填报、复杂的派单排班、多元的客户要求与割裂的数据孤岛.....这些重复低效的管理工作，吞噬了贵司本应用于市场开拓与服务升级的宝贵时间，让公司陷入“忙于管理，疏于发展”的困境，最终成为企业迈向专业化、规模化的隐形枷锁。',
          image: require('@/assets/imgsNew/about2.png')
        },
        {
          title: '小虫单诞生',
          icon: 'el-icon-service',
          content: '专注为PCO解决管理难题，小虫单以轻量化、智能化的解决方案，让企业专注服务本身，告别繁琐低效的工单管理，实现效率与专业的双重飞跃。',
          image: require('@/assets/imgsNew/about3.png')
        },
        {
          title: '核心价值',
          icon: 'el-icon-star-on',
          content: '告别繁琐流程与纸质工单，小虫单直击PCO行业管理痛点，将工单、派单、审批到数据管理等核心环节一站式集成于手机APP助您迎接移动化管理新体验。我们专注于为PCO公司赋能:通过智能派工与流程优化，极大提升现场人效:通过自动生成的专业报告提升您的企业专业形象;通过清晰的数据看板，让客户状态与员工绩效尽在掌握，实现精细化运营。',
          image: require('@/assets/imgsNew/about4.png')
        },
        {
          title: '公司使命',
          icon: 'el-icon-coordinate',
          content: '让PCO公司的每一天，简单而美好。让“简单”成为效率的基石，让“美好”成为工作的注脚。在小虫单，我们通过清晰的流程、协作的智慧，创造每一天的成就感与归属感!',
          image: require('@/assets/imgsNew/about5.png')
        }
      ]
    }
  },
  computed: {
    qrCodeUrl() {
      const downloadLink = 'https://your-download-link.com'
      const encodedText = encodeURIComponent(downloadLink)
      return `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodedText}`
    },
    iosQrSrc() {
      return require('@/assets/IOS App.png')
    },
    safeProductSystems() {
      // 确保 productSystems 始终是一个有效的数组
      return Array.isArray(this.productSystems) ? this.productSystems : []
    }
  },
  mounted() {
    // 监听滚动事件
    window.addEventListener('scroll', this.handleScroll, { passive: true })
    // 监听窗口大小变化
    window.addEventListener('resize', this.checkFeatureCardsScroll, { passive: true })
    // 初始化动画
    this.initAnimations()
    // 平滑滚动设置
    this.setupSmoothScroll()
    // 启动Hero轮播
    this.startHeroCarousel()
    // 检测能力卡片是否需要滚动
    this.$nextTick(() => {
      this.checkFeatureCardsScroll()
    })
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.checkFeatureCardsScroll)
    // 清除Hero轮播定时器
    this.stopHeroCarousel()
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 50
    },
    scrollTo(elementId) {
      // 如果当前不在 homepage 路由，先跳转到 homepage
      if (this.$route.path !== '/homepage') {
        this.$router.push('/homepage').then(() => {
          // 跳转后等待页面渲染完成再滚动
          this.$nextTick(() => {
            this.scrollToElement(elementId)
          })
        })
        return
      }

      // 如果已经在 homepage 页面，直接滚动
      this.scrollToElement(elementId)
    },
    scrollToElement(elementId) {
      const element = document.getElementById(elementId)
      if (element) {
        // Header高度：导航栏70px + 横幅约44px = 114px
        const headerHeight = 114
        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset
        const offsetPosition = elementPosition - headerHeight

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        })
      } else {
        // 如果找不到元素，滚动到页面顶部
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
    },
    initAnimations() {
      // 使用 Intersection Observer 触发动画
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in')
          }
        })
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      })

      // 观察所有需要动画的元素
      this.$nextTick(() => {
        const elements = document.querySelectorAll(
          '.function-card, .pricing-card, .about-card, .usage-row, .feature-row, .feature-card'
        )
        elements.forEach(el => observer.observe(el))
        
        // 动画初始化完成后，检测能力卡片滚动
        setTimeout(() => {
          this.checkFeatureCardsScroll()
        }, 800)
      })
    },
    setupSmoothScroll() {
      // 为页面添加平滑滚动样式
      if (!document.getElementById('smooth-scroll-style')) {
        const style = document.createElement('style')
        style.id = 'smooth-scroll-style'
        style.textContent = 'html { scroll-behavior: smooth; }'
        document.head.appendChild(style)
      }
    },
    handleLogin() {
      window.open('https://platform.xcdan.com/login', '_blank')
    },
    handleDownload() {
      this.qrRevealedPlatform = null
      this.downloadDialogVisible = true
    },
    handleDialogClose(value) {
      this.downloadDialogVisible = value
      if (!value) this.qrRevealedPlatform = null
    },
    handleQrCodeError(event) {
      // 二维码加载失败时的处理
      console.warn('二维码加载失败:', event.target.src)
      // 可以设置一个默认的二维码图片或重新生成
    },
    handleContact() {
      // 跳转到联系表单页面
      this.$router.push('/contact')
    },
    handleTrial() {
      // 跳转到登录/注册页面
      window.open('https://platform.xcdan.com/login', '_blank')
    },
    handleLearnMore() {
      // 跳转到联系表单页面
      this.$router.push('/contact')
    },
    goToHomepage() {
      // Logo 点击跳转到首页
      if (this.$route.path !== '/homepage') {
        this.$router.push('/homepage')
      } else {
        // 如果已经在首页，滚动到顶部
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
    },
    handleImageError(event) {
      // 图片加载失败时的处理
      console.warn('图片加载失败:', event.target.src)
      // 可以设置一个默认图片或隐藏图片
      event.target.style.display = 'none'
    },
    handleLearnMoreClick() {
      // 处理图片中"了解更多"的点击事件
      this.scrollTo('product-functions')
    },
    isFeatureEnabled(featureKey, planTitle) {
      const map = this.featureMatrix[featureKey] || {}
      return !!map[planTitle]
    },
    isUsageEnabled(entryKey, planTitle) {
      const map = this.usageMatrix[entryKey] || {}
      return !!map[planTitle]
    },
    // Hero轮播相关方法
    startHeroCarousel() {
      // 清除已有定时器
      this.stopHeroCarousel()
      // 每1分钟切换一次
      this.heroCarouselTimer = setInterval(() => {
        this.currentHeroIndex = (this.currentHeroIndex + 1) % this.heroImages.length
      }, 5000)
    },
    stopHeroCarousel() {
      if (this.heroCarouselTimer) {
        clearInterval(this.heroCarouselTimer)
        this.heroCarouselTimer = null
      }
    },
    switchHeroImage(index) {
      this.currentHeroIndex = index
      // 切换后重新启动轮播
      this.stopHeroCarousel()
      this.startHeroCarousel()
    },
    checkFeatureCardsScroll() {
      // 检测能力卡片容器是否需要滚动
      this.$nextTick(() => {
        // 延迟检测，确保动画完成
        setTimeout(() => {
          const container = document.querySelector('.feature-cards-container')
          if (container) {
            // 检查内容宽度是否大于容器宽度（留1px容差）
            const needsScroll = container.scrollWidth > container.clientWidth + 1
            if (needsScroll) {
              container.classList.remove('no-scroll')
            } else {
              container.classList.add('no-scroll')
            }
          }
        }, 100)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
// 全局box-sizing
* {
  box-sizing: border-box;
}

.website-page {
  min-height: 100vh;
  background: #ffffff;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  overflow-x: hidden;
  width: 100%;
  max-width: 100vw;
  box-sizing: border-box;
}

// Header样式
.website-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;

  &.scrolled {
    background: rgba(255, 255, 255, 0.98);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  .header-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 40px;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .header-banner {
    background: #1B5898;
    color: #fff;
    padding: 12px 0;

    .banner-content {
      max-width: 1400px;
      margin: 0 auto;
      padding: 0 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 12px;

      .banner-text-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 1;
        flex-wrap: wrap;
        gap: 8px;
        min-width: 0;
      }

      .banner-text {
        font-size: 18px;
        font-weight: 500;
        line-height: 1.5;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        flex-shrink: 0;

        &.banner-text-white {
          color: #ffffff;
          font-size: 20px;
        }

        &.banner-text-yellow {
          color: #FFC133;
        }
      }

      .banner-divider {
        color: #ffffff;
        font-size: 18px;
        margin: 0 20px;
        font-weight: 500;
      }

      .banner-trial-btn {
        background: #FFC133;
        border-color: #FFC133;
        color: #000;
        font-weight: 500;
        padding: 6px 16px;
        border-radius: 12px;
        transition: all 0.3s ease;
        flex-shrink: 0;

        &:hover {
          background: #ffb300;
          border-color: #ffb300;
        }
      }
    }
  }

  .logo-section {
    display: flex;
    align-items: center;
    gap: 12px;
    animation: fadeInLeft 0.6s ease;

    .logo-img {
      width: 40px;
      height: 40px;
      object-fit: contain;
    }

    .logo-text {
      font-size: 20px;
      font-weight: 600;
      color: #1B5898;
    }
  }

  .nav-menu {
    display: flex;
    gap: 40px;
    flex: 1;
    justify-content: center;

    .nav-link {
      color: #333;
      text-decoration: none;
      font-size: 16px;
      font-weight: 500;
      transition: color 0.3s ease;
      position: relative;

      &:hover {
        color: #1B5898;
      }

      &::after {
        content: '';
        position: absolute;
        bottom: -4px;
        left: 0;
        width: 0;
        height: 2px;
        background: #1B5898;
        transition: width 0.3s ease;
      }

      &:hover::after {
        width: 100%;
      }
    }
  }

  .header-actions {
    display: flex;
    align-items: center;
    gap: 20px;

    .contact-info {
      color: #666;
      font-size: 15px;
      display: flex;
      align-items: center;
      gap: 6px;
      
      .phone-icon {
        width: 15px;
        height: 15px;
        color: #666;
        flex-shrink: 0;
      }
    }

    .action-btn {
      color: #333;
      font-size: 14px;
      padding: 0;
      transition: color 0.3s ease;

      &:hover {
        color: #1B5898;
      }
    }

    .download-header-btn {

      border-color: #1B5898;
      color:#1B5898;
      font-weight: 500;
      padding: 8px 20px;
      border-radius: 12px;
      transition: all 0.3s ease;

      &:hover {
        background: #0A3563;
        border-color: #0A3563;
      }
    }

    .contact-header-btn {
      background: #FFC133;
      border-color: #FFC133;
      color: #000;
      font-weight: 500;
      padding: 8px 20px;
      border-radius: 12px;
      transition: all 0.3s ease;

      &:hover {
        background: #ffb300;
        border-color: #ffb300;
      }
    }
  }
}

// Hero区域样式
.hero-section {
  position: relative;
  width: 100%;
  margin-top: 114px; // Header高度：导航栏70px + 横幅约44px = 114px

  .hero-image-wrapper {
    position: relative;
    width: 100%;
    overflow: hidden;
    height: 600px;

    // 占位图片，用于确定容器高度
    .hero-image-placeholder {
      position: relative;
      width: 100%;
      height: 600px;
      opacity: 0;
      pointer-events: none;
      // 保持可见以占据空间，但不显示
      visibility: visible;
      z-index: 0;

      .hero-main-image {
        width: 100%;
        height: auto;
        display: block;
      }
    }

    // 轮播图片
    .hero-image-carousel {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      opacity: 0;
      transition: opacity 0.8s ease-in-out;
      z-index: 1;
      height: 600px;

      &.active {
        opacity: 1;
        z-index: 2;
      }

      .hero-main-image {
        width: 100%;
        height: 100%;
        display: block;
        pointer-events: none; // 让图片不阻止点击事件
      }

      // 图片中"了解更多"的可点击区域
      // 根据图片布局，通常在左侧底部位置
      .hero-learn-more-clickable {
        position: absolute;
        // 根据图片中"了解更多"的实际位置调整
        // 假设在左侧底部，大约在图片左侧10%位置，底部20%位置
        left: 8%;
        bottom: 18%;
        width: 180px;
        height: 60px;
        cursor: pointer;
        z-index: 100;
        pointer-events: auto;
        // 添加一个微妙的悬停效果提示
        border-radius: 8px;
        // 临时添加背景色用于调试，确认位置是否正确（可以注释掉）
        // background: rgba(255, 0, 0, 0.2);

        &:hover {
          background: rgba(27, 88, 152, 0.15);
          transform: scale(1.02);
        }

        &:active {
          background: rgba(27, 88, 152, 0.25);
        }

        // 可以添加一个视觉提示（可选，如果需要的话）
        &::after {
          content: '';
          position: absolute;
          inset: 0;
          border: 2px solid transparent;
          border-radius: 8px;
          transition: all 0.3s ease;
        }

        &:hover::after {
          border-color: rgba(27, 88, 152, 0.4);
        }
      }
    }

    // Hero内容包装容器（使用flex布局避免重合）
    .hero-content-wrapper {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 100;
      width: 90%;
      max-width: 1400px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 60px;
      padding: 0 40px;
      box-sizing: border-box;
    }

    // Logo样式
    .hero-logo {
      flex: 0 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      pointer-events: none;

      .hero-logo-img {
        height: 100%;
        width: auto;
        max-height: 600px;
        object-fit: contain;
        display: block;
        aspect-ratio: auto;
      }
    }

    .hero-logo-second {
      .hero-logo-img {
        max-height: 550px;
      }
    }

    .hero-logo-third {
      .hero-logo-img {
        height: 600px;
        width: auto;
        max-height: none;
        object-fit: contain;
        display: block;
        aspect-ratio: auto;
      }
    }

    // 左侧文字和按钮样式
    .hero-content {
      flex: 0 1 auto;
      max-width: 500px;
      padding: 0 20px;
      color: #000;

      .hero-title {
        font-size: 48px;
        font-weight: 700;
        color: #000;
        margin: 0 0 32px 0;
        line-height: 1.2;
      }

      .hero-title-white {
        color: #fff;
      }

      .hero-features {
        list-style: none;
        padding: 0;
        margin: 0 0 32px 0;

        li {
          font-size: 18px;
          color: #000;
          line-height: 1.5;
          margin-bottom: 0;
          padding-left: 24px;
          position: relative;

          &::before {
            content: '•';
            position: absolute;
            left: 0;
            color: #1B5898;
            font-size: 24px;
            line-height: 1;
          }

          &:last-child {
            margin-bottom: 0;
          }
        }
      }

      .hero-features-white {
        li {
          color: #fff;

          &::before {
            color: #fff;
          }
        }
      }

      .hero-learn-more-btn {
        background: #2882F1;
        border-color: #2882F1;
        color: #fff;
        font-size: 16px;
        font-weight: 500;
        padding: 12px 24px;
        border-radius: 25px;
        transition: all 0.3s ease;
        height: 44px;
        display: inline-flex;
        align-items: center;
        justify-content: center;

        &:hover {
          background: #1a6fd8;
          border-color: #1a6fd8;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(40, 130, 241, 0.3);
        }

        .hero-arrow-circle {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 28px;
          height: 28px;
          background: #fff;
          border-radius: 50%;
          margin-left: 8px;
          flex-shrink: 0;

          .hero-arrow-icon {
            font-size: 14px;
            color: #2882F1;
            line-height: 1;
            display: block;
            font-weight: bold;
            transform: translateY(-1px);
            -webkit-text-stroke: 0.5px #2882F1;
          }
        }
      }
    }

    // 轮播指示器
    .hero-indicators {
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      gap: 12px;
      z-index: 200;
      padding: 8px 16px;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 20px;
      backdrop-filter: blur(10px);
      pointer-events: auto;

      .hero-indicator {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.5);
        cursor: pointer;
        transition: all 0.3s ease;
        border: 2px solid transparent;
        pointer-events: auto;
        user-select: none;

        &:hover {
          background: rgba(255, 255, 255, 0.8);
          transform: scale(1.2);
        }

        &.active {
          background: #FFC133;
          width: 24px;
          border-radius: 5px;
          box-shadow: 0 2px 8px rgba(255, 193, 51, 0.5);
        }
      }
    }
  }
}

// 能力亮点卡片区域样式（横向滑动播放）
.feature-highlight-section {
  padding: 60px 40px;
  background: #f5f7fb;

  .feature-container {
    max-width: 2400px;
    margin: 0 auto;
    width: 100%;
    padding: 0;
    box-sizing: border-box;
    overflow: visible;
  }

  .feature-cards-container {
    display: flex;
    gap: 32px;
    padding: 20px 40px;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: stretch;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
    width: 100%;
    box-sizing: border-box;
    // 确保内容可以超出容器宽度，允许横向滚动
    min-width: 100%;
    // 确保滚动时内容完整显示
    scroll-padding: 0 40px;
    
    // 当内容未溢出时，居中显示并隐藏滚动条
    &.no-scroll {
      justify-content: center;
      overflow-x: hidden;
    }
    
    // 自定义滚动条样式（Webkit浏览器）
    &::-webkit-scrollbar {
      height: 8px;
    }
    
    &::-webkit-scrollbar-track {
      background: transparent;
      border-radius: 4px;
    }
    
    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.2);
      border-radius: 4px;
      transition: background 0.3s ease;
      
      &:hover {
        background: rgba(0, 0, 0, 0.3);
      }
    }
  }

  .feature-card {
    flex: 0 0 400px;
    width: 400px;
    min-width: 400px;
    max-width: 400px;
    flex-shrink: 0;
    background: #ffffff;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);
    transition: all 0.4s ease;
    display: flex;
    flex-direction: column;
    opacity: 0;
    transform: translateY(30px);
    animation: fadeInUp 0.6s ease forwards;

    &:hover {
      box-shadow: 0 16px 40px rgba(15, 23, 42, 0.12);
      transform: translateY(-8px);
    }
  }

  .feature-image-wrapper {
    width: 100%;
    height: 280px;
    overflow: hidden;
    background: #f5f5f5;
    position: relative;

    .feature-image-container {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      
      .feature-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.3s ease;
        display: block;
      }
    }
  }

  .feature-card:hover .feature-image {
    transform: scale(1.05);
  }

  .feature-text {
    padding: 32px 24px;
    display: flex;
    flex-direction: column;
    flex: 1;

    .feature-title {
      font-size: 22px;
      font-weight: 600;
      color: #111827;
      margin: 0 0 16px 0;
      line-height: 1.4;
      transition: color 0.3s ease;
    }

    .feature-desc {
      font-size: 15px;
      line-height: 1.8;
      color: #4b5563;
      margin: 0 0 24px 0;
      flex: 1;
    }

    .feature-link {
      font-size: 16px;
      font-weight: 500;
      padding: 0;
      align-self: flex-start;
      transition: all 0.3s ease;
      color: #1B5898;

      &:hover {
        transform: translateX(4px);
        color: #0A3563;
      }
    }
  }
}


// 产品功能区域样式
.product-functions-section {
  padding: 80px 40px 100px;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 50%, #90caf9 100%);
  min-height: 600px;

  .product-functions-container {
    max-width: 1400px;
    margin: 0 auto;
    text-align: center;
  }

  .product-functions-title {
    font-size: 36px;
    font-weight: 700;
    color: #000;
    margin-bottom: 60px;
    animation: fadeInUp 0.8s ease;
  }

  .function-systems-grid {
    display: grid;
    grid-template-columns: 1.5fr 1fr 1fr 1fr;
    gap: 32px;
    margin-bottom: 60px;
    
    // 确保在小屏幕上不会溢出
    @media (max-width: 1023px) {
      grid-template-columns: repeat(2, 1fr);
      gap: 24px;
    }
    
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      gap: 20px;
    }
  }

  .function-system-card {
    background: #fff;
    border-radius: 30px;
    padding: 40px 24px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    text-align: center;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    &:hover {
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
      transform: translateY(-8px);
    }
  }

  .function-system-title {
    font-size: 24px;
    font-weight: 600;
    color: #000;
    margin: 0 0 24px 0;
    text-align: center;
  }

  .function-items-container {
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
    flex: 1;
    justify-content: center;
    align-items: center;

    &.layout-grid-2x2 {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(2, 1fr);
      gap: 20px;
      justify-items: center;
    }

    &.layout-vertical-2 {
      display: flex;
      flex-direction: column;
      gap: 20px;
      align-items: center;
    }

    &.layout-vertical-3 {
      display: flex;
      flex-direction: column;
      gap: 20px;
      align-items: center;
    }
  }

  .function-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-2px);
    }
  }

  .function-item-icon-wrapper {
    width: 80px;
    height: 80px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    transition: all 0.3s ease;
    overflow: hidden;

    .function-item-icon {
      width: 100%;
      height: 100%;
      object-fit: contain;
      padding: 8px;
      transition: all 0.3s ease;
    }
  }

  .function-item:hover .function-item-icon-wrapper {
    background: #ffffff;
    transform: scale(1.05);

    .function-item-icon {
      transform: scale(1.1);
    }
  }

  .function-item-text {
    font-size: 16px;
    color: #333;
    font-weight: 500;
    text-align: center;
  }

  .product-functions-action {
    margin-top: 40px;

    .learn-more-btn {
      background: #fff;
      color: #1B5898;
      font-size: 18px;
      font-weight: 500;
      padding: 48px 32px;
      border-radius: 30px;
      border: none;
      width: 100%;
      transition: all 0.3s ease;

      &:hover {
        background: #1B5898;
        color: #fff;
        transform: translateX(4px);
      }
    }
  }
}

// 版本价格区域样式
.pricing-section {
  padding: 100px 40px;
  background: #f8f9fa;

  .pricing-container {
    max-width: 1200px;
    margin: 0 auto;
  }

  .section-title {
    font-size: 36px;
    font-weight: 700;
    text-align: center;
    color: #1B5898;
    margin-bottom: 16px;
  }

  .section-subtitle {
    font-size: 18px;
    text-align: center;
    color: #666;
    margin-bottom: 60px;
    line-height: 1.6;
  }

  .pricing-cards {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 32px;
  }

  .pricing-card {
    background: #fff;
    border-radius: 16px;
    padding: 40px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    transition: all 0.3s ease;
    border: 2px solid transparent;
    display: flex;
    flex-direction: column;
    height: 100%;

    &:hover {
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
      transform: translateY(-8px);
      border-color: #FFC133;
    }
  }

  .plan-title {
    font-size: 24px;
    font-weight: 600;
    color: #333;
    margin: 0 0 16px 0;
    text-align: center;
  }

  .plan-description {
    font-size: 16px;
    color: #666;
    line-height: 1.6;
    margin-bottom: 24px;
    text-align: center;
  }

  .plan-pricing {
    margin-bottom: 20px;
    padding: 20px;
    background: #f8f9fa;
    border-radius: 8px;

    .pricing-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
      font-size: 15px;

      &:last-child {
        margin-bottom: 0;
      }

      .pricing-label {
        color: #666;
        font-weight: 500;
      }

      .pricing-value {
        color: #1B5898;
        font-weight: 600;
        font-size: 16px;
      }

      &.pricing-item-monthly {
        justify-content: center;
        flex-direction: column;
        align-items: center;
        gap: 4px;
        margin-bottom: 16px;

        .pricing-value {
          font-size: 30px;

          .pricing-month {
            font-size: 20px;
          }
        }
      }

      .pricing-note-inline {
        font-size: 12px;
        color: #999;
        font-weight: normal;
      }

      &.pricing-item-period {
        justify-content: center;
        margin-bottom: 12px;
      }

      .pricing-period-text {
        font-size: 14px;
        color: #666;
        font-weight: 500;
      }
    }

    .pricing-note-inside {
      margin-top: 0;
      margin-bottom: 0;
      text-align: center;
      padding-top: 8px;
      border-top: 1px solid #e5e7eb;

      .pricing-note-text {
        font-size: 13px;
        color: #999;
        font-style: italic;
      }
    }
  }

  .pricing-note {
    margin-bottom: 20px;
    text-align: center;

    .pricing-note-text {
      font-size: 13px;
      color: #999;
      font-style: italic;
    }
  }

  .plan-specs {
    display: flex;
    justify-content: center;
    margin-bottom: 24px;
    padding: 16px;
    background: #f0f7ff;
    border-radius: 8px;

    .spec-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;

      .spec-label {
        font-size: 14px;
        color: #666;
      }

      .spec-value {
        font-size: 18px;
        color: #1B5898;
        font-weight: 600;
      }
    }
  }

  .plan-features {
    list-style: none;
    padding: 0;
    margin: 0 0 24px 0;
    flex: 1;

    li {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      font-size: 16px;
      color: #333;
      gap: 12px;
    }
  }

  .plan-feature-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    flex-shrink: 0;
  }

  .plan-feature-icon {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .plan-footer {
    margin-top: auto;
    padding-top: 24px;
    border-top: 1px solid #f0f0f0;
  }

  .plan-button {
    width: 100%;
    background: transparent;
    border: none;
    color: #1B5898;
    font-size: 18px;
    font-weight: 500;
    padding: 12px 24px;
    border-radius: 8px;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 0;
      height: 2px;
      background: #1B5898;
      transition: width 0.3s ease;
    }

    &:hover {
      &::after {
        width: 100%;
        background: #1B5898;
      }
    }

    &:active {
      &::after {
        width: 0;
      }
    }
  }
}

// 功能对比区域样式（包含入口配置对比 + 功能对比）
.feature-comparison-section {
  padding: 40px 40px 80px;
  background: #f5f7fb;

  .feature-comparison-container {
    max-width: 1200px;
    margin: 0 auto;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    
    // 在小屏幕上允许横向滚动
    @media (max-width: 1023px) {
      overflow-x: visible;
    }
  }

  .feature-comparison-title {
    font-size: 30px;
    font-weight: 700;
    color: #1B5898;
    text-align: center;
    margin-bottom: 12px;
  }

  .feature-comparison-subtitle {
    font-size: 16px;
    color: #666;
    text-align: center;
    margin-bottom: 32px;
  }

  // 使用入口对比表
  .usage-comparison-table {
    width: 100%;
    border-radius: 16px;
    overflow-x: auto;
    overflow-y: hidden;
    background: #ffffff;
    box-shadow: 0 2px 12px rgba(15, 23, 42, 0.06);
    margin-bottom: 32px;
    -webkit-overflow-scrolling: touch;
    
    // 确保表格在小屏幕上可以横向滚动
    @media (max-width: 1023px) {
      min-width: 600px;
    }
  }

  .usage-comparison-header {
    display: grid;
    grid-template-columns: 2fr repeat(3, 1fr);
    background: #f0f4ff;
    padding: 16px 24px;
    border-bottom: 1px solid #e5e7eb;
  }

  .usage-row {
    display: grid;
    grid-template-columns: 2fr repeat(3, 1fr);
    padding: 16px 24px;
    border-bottom: 1px solid #f1f3f5;
    background: #ffffff;
    transition: background 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;
    opacity: 0;
    transform: translateY(16px);

    &:last-child {
      border-bottom: none;
    }

    &.animate-in {
      opacity: 1;
      transform: translateY(0);
    }

    &:hover {
      background: #f9fafb;
      box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
      transform: translateY(-2px);
    }
  }

  .usage-col {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .usage-col-name {
    justify-content: flex-start;
  }

  .usage-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .usage-name {
    font-size: 15px;
    font-weight: 600;
    color: #111827;
  }

  .usage-desc {
    font-size: 13px;
    color: #6b7280;
  }

  .feature-comparison-table {
    width: 100%;
    border-radius: 16px;
    overflow-x: auto;
    overflow-y: hidden;
    background: #ffffff;
    box-shadow: 0 2px 12px rgba(15, 23, 42, 0.06);
    -webkit-overflow-scrolling: touch;
    
    // 确保表格在小屏幕上可以横向滚动
    @media (max-width: 1023px) {
      min-width: 600px;
    }
  }

  .feature-comparison-header {
    display: grid;
    grid-template-columns: 2fr repeat(3, 1fr);
    background: #f0f4ff;
    padding: 16px 24px;
    border-bottom: 1px solid #e5e7eb;
  }

  .feature-row {
    display: grid;
    grid-template-columns: 2fr repeat(3, 1fr);
    padding: 16px 24px;
    border-bottom: 1px solid #f1f3f5;
    background: #ffffff;
    transition: background 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;
    opacity: 0;
    transform: translateY(16px);

    &:last-child {
      border-bottom: none;
    }

    &.animate-in {
      opacity: 1;
      transform: translateY(0);
    }

    &:hover {
      background: #f9fafb;
      box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
      transform: translateY(-2px);
    }
  }

  .feature-col {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .feature-col-name {
    justify-content: flex-start;
  }

  .feature-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .feature-name {
    font-size: 15px;
    font-weight: 600;
    color: #111827;
  }

  .feature-desc {
    font-size: 13px;
    color: #6b7280;
  }

  .feature-col-plan {
    font-size: 14px;
    color: #111827;
  }

  .feature-dot {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 999px;
    font-size: 14px;
  }

  .feature-dot-na {
    color: #9ca3af;
  }
}

// 关于我们区域样式
.about-section {
  position: relative;
  padding: 100px 40px;
  overflow: hidden;
  min-height: 600px;

  .about-background {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    overflow: hidden;
    background: linear-gradient(135deg, rgba(245, 247, 250, 0.5) 0%, rgba(255, 255, 255, 0.8) 100%);

    .about-bg-image {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: top center;
      transition: transform 0.3s ease;
      display: block;
    }

    .about-bg-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(255, 255, 255, 0.5);
      z-index: 1;
    }

    // 图片加载失败时的占位样式
    &:has(img[style*="display: none"]) {
      background: linear-gradient(135deg, rgba(245, 247, 250, 0.5) 0%, rgba(255, 255, 255, 0.8) 100%);
    }
  }

  .about-container {
    position: relative;
    max-width: 1400px;
    margin: 0 auto;
    z-index: 2;
  }

  .section-title {
    font-size: 48px;
    font-weight: 700;
    text-align: center;
    color: #333;
    margin-bottom: 60px;
    animation: fadeInUp 0.8s ease;
    max-width: 1168px;
    margin-left: auto;
    margin-right: auto;
  }

  .about-cards {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
    justify-items: stretch;
  }

  .about-card {
    background: #fff;
    border-radius: 24px;
    padding: 57px 24px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    transition: all 0.3s ease;
    opacity: 0;
    transform: translateY(24px);
    animation: fadeInUp 0.6s ease forwards;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    &:nth-child(1) {
      animation-delay: 0.1s;
    }

    &:nth-child(2) {
      animation-delay: 0.2s;
    }

    &:nth-child(3) {
      animation-delay: 0.3s;
    }

    &:nth-child(4) {
      animation-delay: 0.4s;
    }

    &:hover {
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
      transform: translateY(-4px);
    }
  }

  .about-card-image-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 24px;
  }

  .about-card-image {
    width: 120px;
    height: 120px;
    object-fit: contain;
    display: block;
    transition: transform 0.3s ease;
  }

  .about-card:hover .about-card-image {
    transform: scale(1.05);
  }

  .about-card-title {
    font-size: 20px;
    font-weight: 600;
    color: #333;
    margin: 0 0 16px 0;
    text-align: center;
  }

  .about-card-content {
    font-size: 14px;
    color: #666;
    line-height: 1.8;
    text-align: center;
    margin: 0;
    flex: 1;
  }
}

// Footer样式
.website-footer {
  padding: 80px 40px 40px;
  background-image: url('@/assets/imgsNew/bottom.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  color: #fff;
  text-align: center;
  position: relative;

  .footer-container {
    max-width: 1200px;
    margin: 0 auto;
  }

  .footer-title {
    font-size: 48px;
    font-weight: 700;
    margin-bottom: 24px;
    animation: fadeInUp 0.8s ease;
  }

  .footer-subtitle {
    font-size: 18px;
    margin-bottom: 40px;
    opacity: 0.9;
    animation: fadeInUp 0.8s ease 0.2s both;
  }

  .footer-logo {
    margin-bottom: 32px;
    animation: fadeInUp 0.8s ease 0.3s both;

    .footer-logo-img {
      width: 80px;
      height: 80px;
      object-fit: contain;
    }
  }

  .footer-actions {
    display: flex;
    justify-content: center;
    gap: 24px;
    margin-bottom: 60px;
    animation: fadeInUp 0.8s ease 0.4s both;

    .footer-btn {
      padding: 24px 40px;
      font-size: 18px;
      border-radius: 24px;
      transition: all 0.3s ease;
      font-weight: 500;

      &.download-btn {
        background: transparent;
        border-color: #FFC133;
        color: #FFC133;

        &:hover {
          background: rgba(255, 193, 51, 0.1);
          border-color: #FFC133;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(255, 193, 51, 0.3);
        }
      }

      &.contact-btn {
        background: #FFC133;
        border-color: #FFC133;
        color: #000;

        &:hover {
          background: #ffb300;
          border-color: #ffb300;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(255, 193, 51, 0.3);
        }
      }
    }
  }

  .footer-copyright {
    font-size: 14px;
    line-height: 1.8;
    background: #000000;
    color: #ffffff;
    padding: 20px;
    margin: 0 calc(-50vw + 50%) -40px calc(-50vw + 50%);
    width: 100vw;
    box-sizing: border-box;

    p {
      color: #ffffff;
      margin: 0;
      max-width: 1200px;
      margin-left: auto;
      margin-right: auto;
      padding: 0 40px;
    }

    a {
      color: #ffffff;
      text-decoration: none;
      margin: 0 8px;

      &:hover {
        text-decoration: underline;
      }
    }

    .beian-icon {
      width: 16px;
      height: 16px;
      margin: 0 8px;
      vertical-align: middle;
    }
  }
}

// 动画定义
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes sparkle {
  0%, 100% {
    transform: scale(1) rotate(0deg);
  }
  50% {
    transform: scale(1.2) rotate(180deg);
  }
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

// 响应式设计
// 超大屏幕优化 (1920px+)
@media (min-width: 1920px) {
  .website-header .header-container,
  .header-banner .banner-content,
  .feature-container,
  .product-functions-container,
  .pricing-container,
  .feature-comparison-container,
  .about-container,
  .footer-container {
    max-width: 1600px;
  }
}

// 大屏幕优化 (1440px - 1919px)
@media (min-width: 1440px) and (max-width: 1919px) {
  .website-header .header-container,
  .header-banner .banner-content,
  .feature-container,
  .product-functions-container,
  .pricing-container,
  .feature-comparison-container,
  .about-container,
  .footer-container {
    max-width: 1400px;
  }
}

// 中等屏幕优化 (1024px - 1439px)
@media (min-width: 1024px) and (max-width: 1439px) {
  .website-header .header-container,
  .header-banner .banner-content {
    padding: 0 30px;
  }

  .feature-highlight-section {
    padding: 50px 30px;

    .feature-container {
      padding: 0;
    }

    .feature-cards-container {
      padding: 20px 30px;
      flex-wrap: nowrap;
      justify-content: flex-start;
      scroll-padding: 0 30px;
      
      &.no-scroll {
        justify-content: center;
        overflow-x: hidden;
      }
    }

    .feature-card {
      flex: 0 0 390px;
      width: 390px;
      min-width: 390px;
      max-width: 390px;
      flex-shrink: 0;
    }
  }

  .product-functions-section {
    padding: 70px 30px 90px;
  }

  .pricing-section {
    padding: 80px 30px;
  }

  .feature-comparison-section {
    padding: 40px 30px 70px;
  }

  .about-section {
    padding: 80px 30px;
  }

  .website-footer {
    padding: 70px 30px 40px;
  }

  .function-systems-grid {
    grid-template-columns: 1.2fr 1fr 1fr 1fr;
    gap: 24px;
  }

  .pricing-cards {
    gap: 24px;
  }

  .usage-comparison-header,
  .usage-row,
  .feature-comparison-header,
  .feature-row {
    grid-template-columns: 1.8fr repeat(3, 1fr);
    padding: 14px 20px;
  }

  .hero-section {
    .hero-image-wrapper {
      .hero-content-wrapper {
        width: 95%;
        gap: 40px;
        padding: 0 30px;
      }

      .hero-content {
        max-width: 40%;
        
        .hero-title {
          font-size: 42px;
        }

        .hero-features li {
          font-size: 17px;
        }
      }

      .hero-logo {
        flex: 0 0 auto;
        
        .hero-logo-img {
          max-width: 100%;
          max-height: 500px;
          height: auto;
        }
      }
    }
  }
}

// 小屏幕优化 (768px - 1023px)
@media (min-width: 768px) and (max-width: 1023px) {
  .website-header .header-container,
  .header-banner .banner-content {
    padding: 0 24px;
  }

  .header-banner {
    .banner-content {
      .banner-text-wrapper {
        flex-wrap: wrap;
        gap: 8px;
      }
      
      .banner-text {
        font-size: 16px;
        white-space: normal;
        
        &.banner-text-white {
          font-size: 18px;
        }
      }
      
      .banner-divider {
        display: none;
      }
    }
  }

  .feature-highlight-section {
    padding: 40px 24px;

    .feature-container {
      padding: 0;
    }

    .feature-cards-container {
      padding: 20px 24px;
      flex-wrap: nowrap;
      justify-content: flex-start;
      scroll-padding: 0 24px;
      
      &.no-scroll {
        justify-content: center;
        overflow-x: hidden;
      }
    }

    .feature-card {
      flex: 0 0 380px;
      width: 380px;
      min-width: 380px;
      max-width: 380px;
      flex-shrink: 0;
    }
  }

  .product-functions-section {
    padding: 60px 24px 80px;
  }

  .pricing-section {
    padding: 70px 24px;
  }

  .feature-comparison-section {
    padding: 40px 24px 60px;
  }

  .about-section {
    padding: 70px 24px;
  }

  .website-footer {
    padding: 60px 24px 30px;
  }

  .function-systems-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  .pricing-cards {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  .about-cards {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  .usage-comparison-header,
  .usage-row,
  .feature-comparison-header,
  .feature-row {
    grid-template-columns: 1.5fr repeat(3, 1fr);
    padding: 12px 16px;
    font-size: 13px;
  }

  .usage-name,
  .feature-name {
    font-size: 14px;
  }

  .usage-desc,
  .feature-desc {
    font-size: 12px;
  }

  .hero-section {
    .hero-image-wrapper {
      .hero-content-wrapper {
        width: 95%;
        gap: 30px;
        padding: 0 24px;
        flex-wrap: wrap;
        justify-content: center;
      }

      .hero-content {
        max-width: 100%;
        flex: 1 1 100%;
        text-align: center;
        
        .hero-title {
          font-size: 36px;
        }

        .hero-features li {
          font-size: 16px;
        }
      }

      .hero-logo {
        flex: 0 0 auto;
        max-width: 50%;
        
        .hero-logo-img {
          max-width: 100%;
          max-height: 400px;
          height: auto;
        }
      }
    }
  }
}

// 原有1200px断点优化
@media (max-width: 1200px) {
  .about-section {
    .about-cards {
      grid-template-columns: repeat(2, 1fr);
      gap: 24px;
    }
  }

  .features-cards-section .cards-container {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .feature-card {
    transform: rotate(0deg) !important;
    margin-top: 0 !important;

    &.animate-in {
      transform: translateY(0) rotate(0deg) !important;
    }

    &:hover {
      transform: translateY(-10px) rotate(0deg) !important;
    }
  }

  .website-header .header-actions {
    flex-wrap: wrap;
    gap: 8px;
  }

  // 能力卡片始终保持一行显示，支持横向滚动
  .feature-cards-container {
    flex-wrap: nowrap;
    justify-content: center;
  }

  .feature-card {
    flex: 0 0 400px;
    width: 400px;
    min-width: 400px;
    max-width: 400px;
  }
}

@media (max-width: 768px) {
  .website-header {
    .header-container {
      padding: 0 20px;
      flex-wrap: wrap;
      height: auto;
      min-height: 70px;
    }

    .logo-section {
      .logo-text {
        font-size: 16px;
      }
    }

    .nav-menu {
      order: 3;
      width: 100%;
      justify-content: space-around;
      padding: 10px 0;
      gap: 15px;
      flex-wrap: wrap;

      .nav-link {
        font-size: 14px;
      }
    }

    .header-actions {
      flex-wrap: wrap;
      gap: 8px;
      order: 2;

      .contact-info {
        display: none;
      }

      .action-btn {
        font-size: 12px;
        padding: 4px 8px;
      }

      .download-header-btn {
        padding: 6px 12px;
        font-size: 12px;
      }

      .contact-header-btn {
        padding: 6px 12px;
        font-size: 12px;
      }
    }

    .header-banner {
      .banner-content {
        padding: 0 20px;
        flex-direction: column;
        gap: 12px;
        text-align: center;

        .banner-text-wrapper {
          width: 100%;
        }

        .banner-text {
          font-size: 14px;
          
          &.banner-text-white {
            color: #ffffff;
            font-size: 16px;
          }
          
          &.banner-text-yellow {
            color: #FFC133;
          }
        }

        .banner-divider {
          margin: 0 12px;
          font-size: 14px;
        }

        .banner-trial-btn {
          padding: 6px 16px;
          font-size: 12px;
          border-radius: 12px;
        }
      }
    }
  }

  .hero-section {
    margin-top: 114px;

    .hero-image-wrapper {
      .hero-learn-more-clickable {
        left: 5%;
        bottom: 12%;
        width: 140px;
        height: 50px;
      }

      .hero-content-wrapper {
        width: 100%;
        gap: 20px;
        padding: 0 20px;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }

      .hero-content {
        max-width: 100%;
        width: 100%;
        padding: 0 20px;
        text-align: center;

        .hero-title {
          font-size: 32px;
          margin-bottom: 24px;
        }

        .hero-features {
          li {
            font-size: 16px;
            margin-bottom: 10px;
          }
        }

        .hero-learn-more-btn {
          padding: 10px 24px;
          font-size: 14px;
        }
      }

      .hero-logo {
        flex: 0 0 auto;
        max-width: 90%;
        
        .hero-logo-img {
          max-width: 100%;
          max-height: 300px;
          height: auto;
        }
      }
    }
  }

  .feature-highlight-section {
    padding: 40px 20px;

    .feature-container {
      padding: 0;
    }

    .feature-cards-container {
      gap: 24px;
      padding: 15px 20px;
      flex-wrap: nowrap;
      justify-content: flex-start;
      // 确保滚动时首尾卡片完整显示
      scroll-padding: 0 20px;
      
      &.no-scroll {
        justify-content: center;
        overflow-x: hidden;
      }
    }

    .feature-card {
      flex: 0 0 350px;
      width: 350px;
      min-width: 350px;
      max-width: 350px;
      // 确保卡片不会被压缩或截断
      flex-shrink: 0;
    }

    .feature-image-wrapper {
      height: 220px;
    }

    .feature-text {
      padding: 24px 20px;

      .feature-title {
        font-size: 18px;
        margin-bottom: 12px;
      }

      .feature-desc {
        font-size: 14px;
        margin-bottom: 20px;
      }
      
      .feature-link {
        font-size: 14px;
      }
    }
  }

  .product-functions-section {
    padding: 60px 20px;

    .product-functions-title {
      font-size: 28px;
      margin-bottom: 40px;
    }

    .function-system-title {
      font-size: 20px;
      margin: 0 0 20px 0;
      text-align: center;
    }

    .function-items-container {
      padding: 0;
      gap: 16px;

      &.layout-grid-2x2 {
        gap: 16px;
      }

      &.layout-vertical-2,
      &.layout-vertical-3 {
        gap: 16px;
      }
    }

    .function-item-icon-wrapper {
      width: 60px;
      height: 60px;

      .function-item-icon {
        padding: 6px;
      }
    }

    .function-item-text {
      font-size: 14px;
    }
  }

  .pricing-section {
    padding: 60px 20px;

    .section-title {
      font-size: 28px;
      margin-bottom: 40px;
    }

    .pricing-cards {
      grid-template-columns: 1fr;
      gap: 24px;
    }

    .pricing-card {
      padding: 32px 24px;
    }
  }

  .about-section {
    padding: 60px 20px;

    .section-title {
      font-size: 32px;
    }

    .about-cards {
      grid-template-columns: 1fr;
      gap: 24px;
    }

    .about-card {
      padding: 57px 24px;
    }
  }

  .website-footer {
    padding: 60px 20px 30px;

    .footer-title {
      font-size: 32px;
    }

    .footer-actions {
      flex-direction: column;
      align-items: center;

      .footer-btn {
        width: 100%;
        max-width: 300px;
        padding: 24px 40px;
        font-size: 18px;
        border-radius: 24px;
      }
    }

    .footer-copyright {
      margin: 0 calc(-50vw + 50%) -30px calc(-50vw + 50%);
      width: 100vw;
      padding: 20px;

      p {
        padding: 0 20px;
      }
    }
  }
}

// 下载二维码弹窗样式
:deep(.download-dialog) {
  .el-dialog {
    border-radius: 20px;
    overflow: hidden;
  }

  .el-dialog__header {
    padding: 0;
    display: none;
  }

  .el-dialog__body {
    padding: 0;
  }

  .el-dialog__close {
    color: #333;
    font-size: 24px;
    z-index: 10;
    position: absolute;
    right: 20px;
    top: 20px;
    transition: all 0.3s ease;

    &:hover {
      color: #1B5898;
      transform: rotate(90deg);
    }
  }
}

.download-content {
  background: linear-gradient(135deg, #e3f2fd 0%, #ffffff 100%);
  padding: 60px 40px;
  text-align: center;
  animation: fadeInUp 0.6s ease;

  .download-title {
    font-size: 32px;
    font-weight: 600;
    margin-bottom: 20px;
    line-height: 1.5;

    .title-text-black {
      color: #000000;
    }

    .title-text-blue {
      color: #1B5898;
    }
  }

  .download-desc {
    font-size: 16px;
    color: #333;
    line-height: 1.6;
    margin-bottom: 40px;
    padding: 0 20px;
  }

  .qr-codes-row {
    display: flex;
    justify-content: center;
    align-items: stretch;
    gap: 32px;
    margin-bottom: 28px;
    flex-wrap: wrap;
  }

  .qr-card {
    flex: 0 0 auto;
    width: 272px;
    background: #ffffff;
    border-radius: 20px;
    padding: 28px 24px;
    box-shadow: 0 4px 24px rgba(27, 88, 152, 0.06);
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
    animation: fadeInUp 0.5s ease both;
    border: 1px solid rgba(27, 88, 152, 0.08);
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 3px;
      opacity: 0;
      transition: opacity 0.3s ease;
    }

    &.qr-card-android {
      animation-delay: 0.15s;

      &::before {
        background: linear-gradient(90deg, #3ddc84 0%, #2e7d32 100%);
      }
    }

    &.qr-card-ios {
      animation-delay: 0.25s;

      &::before {
        background: linear-gradient(90deg, #555 0%, #1d1d1f 100%);
      }
    }

    &:hover,
    &.is-revealed-tap {
      .qr-mask-layer {
        opacity: 0;
        pointer-events: none;
      }

      .qr-code-layer {
        opacity: 1;
      }
    }

    &:hover {
      transform: translateY(-6px);
      box-shadow: 0 16px 36px rgba(27, 88, 152, 0.12);
      border-color: rgba(27, 88, 152, 0.14);

      &::before {
        opacity: 1;
      }
    }

    .qr-card-reveal {
      position: relative;
      width: 200px;
      height: 240px;
      border-radius: 14px;
      overflow: hidden;
      background: #f8fafc;
    }

    .qr-code-layer {
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 16px;
      opacity: 0;
      transition: opacity 0.35s ease;

      .qr-code-image {
        width: 100%;
        height: 100%;
        object-fit: contain;
        display: block;
      }
    }

    .qr-mask-layer {
      position: absolute;
      inset: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: #ffffff;
      border-radius: 14px;
      box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.04);
      opacity: 1;
      transition: opacity 0.35s ease;
      cursor: pointer;
    }

    .qr-mask-icon {
      width: 56px;
      height: 56px;
      object-fit: contain;
      margin-bottom: 14px;
      flex-shrink: 0;
    }

    .qr-mask-label {
      font-size: 15px;
      font-weight: 600;
      color: #334155;
      text-align: center;
      line-height: 1.4;
      padding: 0 8px;
    }

    .qr-mask-tip {
      font-size: 12px;
      color: #94a3b8;
      margin-top: 12px;
    }

    .qr-card-hint {
      font-size: 13px;
      color: #64748b;
      margin-top: 16px;
      margin-bottom: 0;
    }
  }

  .download-hint {
    font-size: 14px;
    color: #64748b;
    line-height: 1.6;
    margin: 0;
    animation: fadeInUp 0.6s ease 0.35s both;
  }
}

// 响应式设计
@media (max-width: 768px) {
  :deep(.download-dialog) {
    .el-dialog {
      width: 90% !important;
      margin: 5vh auto;
    }
  }

  .download-content {
    padding: 40px 20px;

    .download-title {
      font-size: 24px;
    }

    .download-desc {
      font-size: 14px;
      margin-bottom: 30px;
    }

    .qr-codes-row {
      flex-direction: column;
      gap: 24px;
    }

    .qr-card {
      width: 100%;
      max-width: 280px;
      margin: 0 auto;

      .qr-card-reveal {
        width: 200px;
        height: 240px;
      }
    }

    .download-hint {
      font-size: 13px;
    }
  }
}
</style>



